export default __webpack_public_path__ + "static/media/overview_reg.70368dc6.gif";